/* eslint-disable */
// PropertyLimitBanner.js
// Add to Properties.js:
//   import { PropertyLimitBanner } from '../billing/PropertyLimitBanner';
//   import { useBilling } from '../billing/BillingContext';
//   const { isAtUnitLimit, billing } = useBilling();
//   Render <PropertyLimitBanner /> at top of property list
//
// PRICE-005: this banner only exists for Free and Solo — the two
// HARD-capped plans. Standard, Pro and Agency are soft-capped: they are
// never blocked from adding a property or room, they're billed for the
// units above their allowance instead (see BillingSettings.js for that
// ongoing-cost notice). Showing a "limit reached" banner on a plan that
// can never actually reach a limit would be simply wrong, so this
// component returns null for every soft-capped plan regardless of usage.

import React, { useState } from 'react';
import { useBilling } from '../billing/BillingContext';
import { UpgradeModal } from '../billing/UpgradePrompts';

const HARD_CAPPED_PLANS = ['free', 'solo'];

export function PropertyLimitBanner() {
    const { billing, isAtUnitLimit } = useBilling();
    const [showModal, setShowModal]  = useState(false);

    const plan = billing?.plan || 'free';
    if (!HARD_CAPPED_PLANS.includes(plan)) return null; // soft-capped: never blocked, nothing to show here
    if (!isAtUnitLimit()) return null;

    const limit = billing?.includedUnits ?? 4;
    const used  = billing?.billableUnits ?? 0;

    const messages = {
        free: `You've used all ${limit} free let units. Upgrade to Solo to unlock reports and AI scanning at the same size, or Standard for more units.`,
        solo: `You've used all ${limit} let units on Solo. Upgrade to Standard for 24 units, or Pro for 60.`,
    };

    return (
        <>
            <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '0.75rem', padding: '1rem 1.25rem', marginBottom: '1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.625rem' }}>
                    <span style={{ fontSize: '1.25rem' }}>⚠️</span>
                    <div>
                        <div style={{ fontWeight: 700, fontSize: '0.9375rem', color: '#92400e' }}>
                            Let unit limit reached ({used}/{limit})
                        </div>
                        <div style={{ fontSize: '0.8125rem', color: '#b45309', marginTop: '0.125rem' }}>
                            {messages[plan] || messages.free}
                        </div>
                    </div>
                </div>
                <button onClick={() => setShowModal(true)} style={{ background: '#d97706', color: '#fff', border: 'none', borderRadius: '0.5rem', padding: '0.5rem 1rem', fontWeight: 700, fontSize: '0.875rem', cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 }}>
                    Upgrade Now →
                </button>
            </div>
            {showModal && <UpgradeModal feature="units" onClose={() => setShowModal(false)} />}
        </>
    );
}
